import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


import IpadView from './components/IpadView';
import IpadRegister from "./components/IpadRegister";
import IpadAvatar from "./components/IpadAvatar";
import IpadMyProfile from "./components/IpadMyProfile";
import IpadLobbyGame from "./components/IpadLobbyGame";
import IpadCoverCasoClinico from "./components/IpadCoverCasoClinico";
import IpadCoverCasoClinico2 from "./components/IpadCoverCasoClinico2";
import IpadCoverCasoClinico3 from "./components/IpadCoverCasoClinico3";
import IpadCoverCasoClinico4 from "./components/IpadCoverCasoClinico4";
import IpadCoverCasoClinico5 from "./components/IpadCoverCasoClinico5";
import IpadDomanda from "./components/IpadDomanda";
import IpadDomanda2 from "./components/IpadDomanda2";
import IpadDomanda3 from "./components/IpadDomanda3";
import IpadDomanda4 from "./components/IpadDomanda4";
import IpadDomanda5 from "./components/IpadDomanda5";
import IpadAttesaSfidante from "./components/IpadAttesaSfidante";
//import IpadHaiVinto from "./components/IpadHaiVinto";
//import IpadHaiPerso from "./components/IpadHaiPerso";
//import IpadClassificaGen from "./components/IpadClassificaGen";
import IpadGameover from "./components/IpadGameover";

import MonitorView from './components/MonitorView';
import MonitorCC from './components/MonitorCC';
import MonitorClassGen from './components/MonitorClassGen';


import './assets/fonts/fonts.css';

//import io from 'socket.io-client';
//import axios from 'axios';


function App() {

    console.log("APP API Base URL:", process.env.REACT_APP_API_BASE_URL);

  return (


      <Router>
         {/*<div className="max-w-[2048px] max-h-[1536px] flex flex-col w-full h-full ">*/}
         <div className="flex flex-col w-full h-full ">

                  <Routes>
                      <Route path="/ipad" element={<IpadView/>}/>
                      <Route path="/ipad/register" element={<IpadRegister/>}/>
                      <Route path="/ipad/avatar" element={<IpadAvatar/>}/>
                      <Route path="/ipad/myprofile" element={<IpadMyProfile/>}/>
                      <Route path="/ipad/lobbygame" element={<IpadLobbyGame/>}/>

                      <Route path="/ipad/cover-cc" element={<IpadCoverCasoClinico/>}/>
                      <Route path="/ipad/cover-cc-2" element={<IpadCoverCasoClinico2/>}/>
                      <Route path="/ipad/cover-cc-3" element={<IpadCoverCasoClinico3/>}/>
                      <Route path="/ipad/cover-cc-4" element={<IpadCoverCasoClinico4/>}/>
                      <Route path="/ipad/cover-cc-5" element={<IpadCoverCasoClinico5/>}/>

                      <Route path="/ipad/domanda" element={<IpadDomanda/>}/>
                      <Route path="/ipad/domanda2" element={<IpadDomanda2/>}/>
                      <Route path="/ipad/domanda3" element={<IpadDomanda3/>}/>
                      <Route path="/ipad/domanda4" element={<IpadDomanda4/>}/>
                      <Route path="/ipad/domanda5" element={<IpadDomanda5/>}/>

                      <Route path="/ipad/attesasfidante" element={<IpadAttesaSfidante/>}/>
                      {/*<Route path="/ipad/haivinto" element={<IpadHaiVinto/>}/>
                      <Route path="/ipad/haiperso" element={<IpadHaiPerso/>}/>
                      <Route path="/ipad/classificagenerale" element={<IpadClassificaGen/>}/>*/}

                      <Route path="/ipad/gameover" element={<IpadGameover/>}/>

                      <Route path="/monitor" element={<MonitorView/>}/>
                      <Route path="/monitor-cc" element={<MonitorCC/>}/>
                      <Route path="/monitor-classgen" element={<MonitorClassGen/>}/>
                  </Routes>
              </div>
      </Router>

);
}

export default App;
